var ColorService = /** @class */ (function () {
    function ColorService() {
    }
    ColorService.prototype.hexToRgb = function (hex) {
        var regex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
        var outputArr = regex.exec(hex);
        if (!outputArr || !outputArr.length) {
            throw new Error(hex + " is not hex color format!");
        }
        var output = {
            r: parseInt(outputArr[1], 16),
            g: parseInt(outputArr[2], 16),
            b: parseInt(outputArr[3], 16)
        };
        return output;
    };
    ColorService.prototype.rgbToHex = function (color) {
        return ((color.r << 16) + (color.g << 8) + color.b).toString();
    };
    ColorService.prototype.darken = function (color, factor) {
        var output = Object.assign({}, color);
        var parsedFactor = 1 - factor;
        Object.keys(color).forEach(function (color) { return output[color] *= parsedFactor; });
        return output;
    };
    return ColorService;
}());
var instance = new ColorService();
export default instance;
